module.exports = __webpack_public_path__ + "static/media/rider_bg.3298dd0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rider_bg.png
// module id = 1150
// module chunks = 2